<!-- $emit click-attachment: when orange button is clicked -->

<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        small
        depressed
        v-on="on"
        @click="getProcessLeaf(processId)"
      >
        {{ $t('eDocInternal.processProgress') }}
      </v-btn>
    </template>
    <v-card>
      <v-skeleton-loader
        v-if="pageLoading"
        type="list-item-avatar"
      />
      <div
        v-if="!pageLoading"
        class="pa-4"
      >
        <template v-if="showingFlowId === null">
          <v-card-title class="mx-n4">
            {{ $t('eDocInternal.theLastProcessPerson') }}
          </v-card-title>
          <v-card
            v-for="(leaf, index) in processLeaf"
            :key="index"
            class="d-inline-block mr-2 mb-2 pa-4 teal lighten-5"
            rounded
            elevation="4"
            @click="getAncestorProcess(leaf.id, index)"
          >
            <div class="text-body-2">
              {{ leaf.receiverSubunitAbbr }}
            </div>
            <div>
              {{ showReceiverOrGroupName(leaf) }}
              <!-- {{ $chPtObjData('chinReceiverName',leaf) }} -->
            </div>
            <div class="text-body-2 grey--text">
              <template v-if="leaf.statusCode === 'C'">
                {{ momentWithHyphen(leaf.modifiedTime).format('YYYY-MM-DD HH:mm') }}
                <br>({{ $t('eDocInternal.completeTime') }})
              </template>
              <template v-else-if="leaf.confirmReceivedTime">
                {{ momentWithHyphen(leaf.confirmReceivedTime).format('YYYY-MM-DD HH:mm') }}
                <br>({{ $t('eDocInternal.confirmReceivedTime') }})
              </template>
              <template v-else>
                {{ $t('eDocInternal.unRead') }}
              </template>
            </div>
          </v-card>
        </template>
        <template v-else>
          <v-btn icon>
            <v-icon @click="showingFlowId = null">
              {{ mdiArrowLeft }}
            </v-icon>
          </v-btn>
          <v-skeleton-loader
            v-if="nodeLoading"
            type="list-item-avatar, divider, list-item-avatar"
          />
          <div
            v-if="!nodeLoading"
            class="ml-0 ml-md-10"
          >
            <table>
              <thead>
                <tr>
                  <th />
                  <th class="text-center" />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in ancestorProcess"
                  :key="`anc${item.id}`"
                >
                  <td class="text-center">
                    <v-card
                      class="pa-2 text-left"
                      flat
                    >
                      <div class="text-body-2">
                        {{ item.senderSubunitAbbr }}
                      </div>
                      <div>
                        {{ showSenderOrGroupName(item) }}
                      </div>
                      <div class="text-body-2 grey--text">
                        {{ momentWithHyphen(item.createdTime).format('YYYY-MM-DD HH:mm') }}
                      </div>
                    </v-card>
                    <v-icon icon>
                      {{ mdiArrowDownBoldOutline }}
                    </v-icon>
                  </td>
                  <td class="pl-4">
                    <div class="mb-6">
                      <span class="font-weight-bold">“</span>
                      {{ item.senderInstruction }}
                      <span class="font-weight-bold">”</span>
                    </div>
                  </td>
                </tr>
                <!-- last process -->
                <tr>
                  <td class="text-center">
                    <v-card
                      class="pa-2 text-left"
                      flat
                    >
                      <div class="text-body-2">
                        {{ lastProcess.receiverSubunitAbbr }}
                      </div>
                      <div>
                        {{ showReceiverOrGroupName(lastProcess) }}
                      </div>
                    </v-card>
                  </td>
                  <td class="pl-4" />
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'
import docFlowApi from '@/api/eDocInternal/docFlow'
import { mdiArrowLeft, mdiArrowDownBoldOutline } from '@mdi/js'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import { mapState } from 'vuex'
import { docFlowModule } from '@/store/moduleName'

export default {
  mixins: [docFlowMethod],
  props: {
    processId: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      mdiArrowDownBoldOutline: mdiArrowDownBoldOutline,
      mdiArrowLeft: mdiArrowLeft,
      dialog: false,
      showingFlowId: null,
      processLeaf: [],
      ancestorProcess: [],
      lastProcess: null,
      pageLoading: false,
      nodeLoading: false
    }
  },
  computed: {
    ...mapState(docFlowModule, {
      inflowStatus: state => state.inflowStatus
    })
  },
  created () {
    // this.getProcessLeaf(this.processId)
  },
  methods: {
    async getProcessLeaf (processId) {
      this.pageLoading = true
      await docFlowApi.getProcessLeaf(processId, resp => {
        this.processLeaf = resp.data
      })
      this.pageLoading = false
    },
    async getAncestorProcess (processId, index) {
      this.nodeLoading = true
      this.showingFlowId = 1
      this.lastProcess = this.processLeaf[index]
      await docFlowApi.getAncestorProcess(processId, this.inflowStatus, resp => {
        this.ancestorProcess = resp.data
      })
      this.nodeLoading = false
    },

    momentWithHyphen
  }
}
</script>
